import AboutSection from '../components/AboutSection';

export default function AboutPage() {
  return <>
    <AboutSection />
  </>;
}
